import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogService } from '@app/core/services/dialog/dialog.service';
import { FormField } from '@app/shared/models/field.interface';
import { Entity } from '@app/shared/models/models.interface';

//FIXME: remove this component!
@Component({
  selector: 'vfs-detail-form',
  templateUrl: './detail-form.component.html',
  styleUrls: ['./detail-form.component.scss']
})
export class DetailFormComponent<T extends Entity> implements OnInit {
  @Input() fields: FormField[];
  @Input() formGroup: FormGroup;
  @Input() data: T;
  @Input() entity: string;
  @Output() deleteForm = new EventEmitter<string>();
  @Output() saveForm = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  constructor(private dialogService: DialogService) {}

  ngOnInit() {
    this.formGroup.patchValue(this.data);
    this.formGroup.markAsPristine();
  }

  save() {
    this.saveForm.emit();
  }

  discard() {
    this.closeForm.emit();
  }
}
